import { load3DLogo } from '../../vendor/index.js';

export default {
	init() {
		$('.popup_strategie-web').css('height', $(window).height() + 'px');
		$(
			'.module-strategie-web .gform-body .gform_page_fields .image-choices-choice-image-wrap img'
		).each(function () {
			const import_url_image = $(this).attr('data-lightbox-src');
			$(this)
				.parent()
				.css('mask-image', 'url(' + import_url_image + ')');
			$(this)
				.parent()
				.css('-webkit-mask-image', 'url(' + import_url_image + ')');
		});

		$(
			'.popup_strategie-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible.url .ginput_container_text'
		).each(function () {
			$(this).append('<span class="focus-border"></span>');
		});

		$(
			'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
		).each(function () {
			$(this).next().append($(this));
		});

		$(
			'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_strategie-web .other input'
		).each(function () {
			$(this).focusout(function () {
				if ($(this).val() != '') {
					$(this).addClass('has-content');
				} else {
					$(this).removeClass('has-content');
					$(this).val('');
				}
			});
		});

		let scene3D;

		MutationObserver =
			window.MutationObserver || window.WebKitMutationObserver;

		var observer = new MutationObserver(function (mutations, observer) {
			$(
				'.module-strategie-web .gform-body .gform_page_fields .image-choices-choice-image-wrap img'
			).each(function () {
				const import_url_image = $(this).attr('src');
				$(this)
					.parent()
					.css('mask-image', 'url(' + import_url_image + ')');
				$(this)
					.parent()
					.css('-webkit-mask-image', 'url(' + import_url_image + ')');
			});
		});

		observer.observe(
			document.getElementsByClassName('popup_strategie-web')[0],
			{
				subtree: true,
				attributes: true,
			}
		);

		function openPopup() {
			const logoContainer = $('.wrap_popup .logo_3d_strategie_web');
			load3DLogo({ container: logoContainer[0], dark: true }).then(
				(scene) => {
					scene3D = scene;
					scene3D.play();
				}
			);

			$('.popup_strategie-web').addClass('open');
			$('html').addClass('popup');
			$('.module-strategie-web').css({ pointerEvents: 'auto' });
			if (
				$(
					'.module-strategie-web .popup_strategie-web .popup_content'
				).find('.gform_confirmation_wrapper').length !== 0
			) {
				$(
					'.module-strategie-web .popup_strategie-web .wrap_popup .logo_3d'
				).css('display', 'block');
			}
		}

		$('.btn[data-popup="free-analyse"]').on('click', openPopup);

		$('.popup_strategie-web .close').on('click', function () {
			$('.popup_strategie-web').removeClass('open');
			$('html').removeClass('popup');
			$('.module-strategie-web').css({ pointerEvents: 'none' });

			if (scene3D) {
				scene3D.pause();
			}
		});

		$('.popup_strategie-web .gfield_radio .gchoice:last-child input').on(
			'change',
			function (e) {
				$(this)
					.parents('.form_conception')
					.animate({ scrollTop: $(document).height() }, 1000);
			}
		);

		jQuery(document).on(
			'gform_page_loaded',
			function (event, form_id, current_page) {
				$(
					'.popup_strategie-web .gfield_radio .gchoice:last-child input'
				).on('change', function (e) {
					$(this)
						.parents('.form_conception')
						.animate({ scrollTop: $(document).height() }, 1000);
				});

				$(
					'.popup_strategie-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
				).each(function () {
					$(this).append('<span class="focus-border"></span>');
				});

				$(
					'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_strategie-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input, .popup_strategie-web .gform_body .other input'
				).each(function () {
					if ($(this).val() != '') {
						$(this).addClass('has-content');
					} else {
						$(this).removeClass('has-content');
						$(this).val('');
					}

					$(this).focusout(function () {
						if ($(this).val() != '') {
							$(this).addClass('has-content');
						} else {
							$(this).removeClass('has-content');
							$(this).val('');
						}
					});
				});

				$(
					'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
				).each(function () {
					$(this).next().append($(this));
				});

				$(
					'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea'
				).append(function () {
					var label_inside = $(
						'.popup_strategie-web .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label'
					);
					return label_inside;
				});
			}
		);
	},
};
